// Auto-expanding textarea hook
const AutoExpandTextarea = {
  mounted() {
    this.adjustHeight();

    // Focus the textarea after a short delay to work around sandboxed iframe restrictions
    // The autofocus attribute may be blocked in cross-origin iframes, so we use JS as fallback
    setTimeout(() => {
      this.el.focus();
    }, 100);

    this.el.addEventListener('input', () => {
      this.adjustHeight();
    });

    // Reset on form submit
    this.el.form?.addEventListener('submit', () => {
      setTimeout(() => {
        this.el.value = '';
        this.adjustHeight();
        this.el.focus();
      }, 0);
    });

    // Handle Enter key (submit) vs Shift+Enter (new line)
    this.el.addEventListener('keydown', (e) => {
      // Skip while an IME (e.g. Japanese/Chinese/Korean) is composing —
      // Enter is used to confirm the conversion, not submit the form.
      if (e.isComposing || e.keyCode === 229) return;
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.el.form?.requestSubmit();
      }
    });

    // Listen for focus event from server
    this.handleEvent('focus_input', () => {
      this.el.focus();
    });
  },

  updated() {
    this.adjustHeight();
  },

  adjustHeight() {
    // Reset height to recalculate
    this.el.style.height = 'auto';

    // Set height based on content, with min and max
    const maxHeight = 200; // ~10 rows
    const newHeight = Math.min(this.el.scrollHeight, maxHeight);

    this.el.style.height = newHeight + 'px';
    this.el.style.overflowY = newHeight >= maxHeight ? 'auto' : 'hidden';
  }
};

export default AutoExpandTextarea;
